<app-form-container [heading]="formTitle" [formGroup]="depositForm">
  @if (!isSettlementApp) {
    <div class="form-group">
      <app-dropdown
        label="User type"
        placeholder="Select user type"
        [options]="userTypeOptions"
        formControlName="userType"
        [isInvalid]="getFieldError('userType', 'User type') !== ''"
        [errorMessage]="getFieldError('userType', 'User type')"
      />
    </div>

    @if (depositForm.get('userType')?.value) {
      <div class="form-group" animate.enter="expand-in" animate.leave="collapse-out">
        <app-dropdown
          [label]="identifierLabel"
          placeholder="Select identifier"
          [options]="identifierOptions"
          formControlName="identifier"
          [isSearch]="true"
          [searchPlaceholder]="'Search or Add'"
          [allowAdd]="true"
          [addButtonLabel]="'Add ' + identifierLabel"
          (addItem)="onAddIdentifier($event)"
          [isInvalid]="getFieldError('identifier', 'Identifier') !== ''"
          [errorMessage]="getFieldError('identifier', 'Identifier')"
        />
      </div>
    }
  }

  <div class="form-group">
    <app-blockchain-dropdown
      label="Blockchain"
      placeholder="Select Blockchain"
      [options]="blockchainOptions()"
      formControlName="blockchain"
      [isInvalid]="getFieldError('blockchain', 'Blockchain') !== ''"
      [errorMessage]="getFieldError('blockchain', 'Blockchain')"
    />
  </div>

  @if (isSettlementApp) {
    <div class="form-group wallet-group" #walletGroup>
      <div class="wallet-selection">
        <app-dropdown
          #walletDropdown
          label="Wallet"
          placeholder="Select Wallet"
          [options]="walletOptions"
          formControlName="selectedWallet"
        ></app-dropdown>

        <ng-container *appHasPermission="{ resource: walletResource, scope: Scopes.Create }">
          <span class="separator">or</span>
          <button
            type="button"
            class="generate-wallet-btn"
            [disabled]="isGenerateDisabled"
            (click)="generateWallet()"
          >
            @if (!generatingWallet) {
              <span>{{ walletGenerationText }}</span>
            } @else {
              <span class="spinner-container"> <mat-spinner diameter="20"></mat-spinner> Creating... </span>
            }
          </button>
        </ng-container>
      </div>
    </div>
  }

  @if (!isSettlementApp) {
    <div class="form-group">
      <app-dropdown
        label="Wallet type"
        placeholder="Select wallet type"
        [options]="walletTypeOptions"
        formControlName="walletType"
        [isInvalid]="getFieldError('walletType', 'Wallet type') !== ''"
        [errorMessage]="getFieldError('walletType', 'Wallet type')"
      />
    </div>
  }

  <div class="form-group">
    <app-dropdown
      label="Currency"
      placeholder="Select Currency"
      [options]="currencyOptions"
      formControlName="selectedCurrency"
    />
  </div>

  <div class="form-group">
    <app-text-input
      label="Amount (Optional)"
      type="number"
      placeholder="Enter amount"
      [precision]="currencyPrecision"
      formControlName="amount"
      [showRestField]="true"
      (restField)="onResetAmount()"
      [disable]="isAmountDisabled"
      [isInvalid]="getFieldError('amount', 'Amount') !== ''"
      [errorMessage]="getFieldError('amount', 'Amount')"
    />
  </div>

  <div class="form-actions">
    <app-button
      *appHasPermission="{ resource: transactionResource, scope: Scopes.Create }"
      buttonVariant="form-primary"
      buttonType="button"
      [state]="submitButtonState"
      (buttonClick)="onSubmit()"
    >
      {{ submitButtonText }}
    </app-button>
  </div>
</app-form-container>
